<template>
    <v-container style="padding-top: 0px;padding-bottom: 0px">
        <footer id="footer">
            <v-layout>
                <v-flex xs4 sm4 md4 lg4 xl4>
                    <div class="footer-logo">
                        <a class="logo-image" href="" title="">
                            <img src="/home/images/logo-footer.png" alt="logo footer">
                        </a>
                    </div>
                </v-flex>
                <v-flex xs8 sm8 md8 lg8 xl8 id="menu-footer" class="col-md-8 col-sm-8">
                    <v-layout wrap>
                        <v-flex>
                            <div class="col-md-5 col-sm-5">
                                <div style="text-align: left">
                                    <p class="primaryColor">YOCLASS</p>
                                    <ul>

                                        <li>
                                            <a href="#">Giải pháp</a>
                                        </li>
                                        <li>
                                            <a href="#">Điều khoản sử dụng</a>
                                        </li>
                                        <li>
                                            <a href="#">Chính sách bảo mật</a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </v-flex>
                        <v-flex>
                            <div style="text-align: left">
                                <p class="primaryColor">LIÊN HỆ VỚI CHÚNG TÔI</p>
                                <ul style="list-style-type: none; padding-left: 0px">
                                    <li style="">
                                        <a>
                                            <v-icon dark>location_on</v-icon>
                                            Tòa nhà JoyHouse, Lô B2/D21
                                            <br>
                                            Khu ĐTM Cầu giấy, Dịch Vọng Hậu, Cầu Giấy, HN
                                        </a>
                                    </li>
                                    <li>
                                        <a>
                                            <v-icon dark>smartphone</v-icon>
                                            096 881 8899
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </v-flex>
                    </v-layout>
                </v-flex>
            </v-layout>

            <div id="copyring">
                Copy Right 2020. Interland. Jsc
            </div>
        </footer>
    </v-container>
</template>
<script>
    export default {
        name: "app-footer",
        components: {},
        data() {
            return {};
        },
    };
</script>
